<template>

  <ModalContainer queryParam="f003" ref="modalContainer" size="lg">

    <b-alert v-if="messageAlert" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <div>

        <h4 class="text-primary text-center mb-2">003 HOSPITALIZACIÓN</h4>

        <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success"
          active-tab-class="font-weight-bold text-success">
          <b-tab title="Consulta/Antecdentes" active>
            <b-card>
            
              <span>Antecedentes Patológicos Personales</span>
              <b-row>


                <b-col cols="3" class="my-1">
                  <label>Alergias a medicamentos:</label>
                  <b-form-input v-model="hospitalizacion.alergiaMedicamentos" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Otras alergias:</label>
                  <b-form-input v-model="hospitalizacion.otrasAlergias" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Vacunas:</label>
                  <b-form-input v-model="hospitalizacion.vacunas" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Patologias Clinicas:</label>
                  <b-form-input v-model="hospitalizacion.patologiasClinicas" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Medicacion Habitual:</label>
                  <b-form-input v-model="hospitalizacion.medicacionHabitual" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Quirurgicos:</label>
                  <b-form-input v-model="hospitalizacion.quirurgicos" />
                </b-col>
                <b-col cols="3" class="my-1">
                  <label>Hábitos:</label>
                  <b-form-input v-model="hospitalizacion.habitos" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Condicion Socio-Economica:</label>
                  <b-form-input v-model="hospitalizacion.condicionSocioEconomica" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Discapacidad:</label>
                  <b-form-input v-model="hospitalizacion.discapacidad" />
                </b-col>

                <b-col cols="3" class="my-1">
                  <label>Religion:</label>
                  <b-form-input v-model="hospitalizacion.religion" />
                </b-col>
                <b-col cols="3" class="my-1">
                  <label>Tipificacion Sanguinea:</label>
                  <b-form-input v-model="hospitalizacion.tripificacionSanguinea" />
                </b-col>





              </b-row>

            </b-card>
          </b-tab>
          <b-tab title="Constantes/Plan de Tratamiento" active>
            <b-card>
              <b-row>
                <b-col>

                  <b-alert variant="success" v-if="hospitalizacion.constantesVitales" show>

                    <div class="row mt-1 p-1">
                      <div class="col-4">
                        <label class="text-dark text-center">Tension Arterial: <span> {{
                          hospitalizacion.constantesVitales.tensionArterial }}</span> </label>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Frecuencia Cardiaca: <span> {{
                          hospitalizacion.constantesVitales.frecuenciaCardiaca }}</span> </label>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Frecuencia Respiratoria: <span> {{
                          hospitalizacion.constantesVitales.frecuenciaRespiratoria }} </span> </label>

                      </div>
                    </div>
                    <div class="row mt-1 p-1">
                      <div class="col-4">
                        <label class="text-dark text-center">Temperatura: <span>{{
                          hospitalizacion.constantesVitales.temperatura }}</span> °</label>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Sat Oxigeno: <span>{{
                          hospitalizacion.constantesVitales.saturacionOxigeno }}</span></label>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Talla (cm): <span>{{ hospitalizacion.constantesVitales.talla
                            }}</span> </label>

                      </div>
                    </div>
                    <div class="row mt-1 p-1">
                      <div class="col-4">
                        <label class="text-dark text-center">Peso (kg): <span> {{ hospitalizacion.constantesVitales.peso
                            }}</span> </label>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Imc (kg/m2): <span> {{ hospitalizacion.constantesVitales.imc
                            }}</span> </label>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Score Mama:</label> <b-form-input
                          placeholder="Ingrese indice glascow" v-model="hospitalizacion.scoreMama"></b-form-input>

                      </div>
                      <div class="col-4">
                        <label class="text-dark text-center">Otros:</label> <b-form-input
                          placeholder="Ingrese indice glascow" v-model="hospitalizacion.constantesVitales.otros"></b-form-input>

                      </div>
                    </div>
                  </b-alert>
                  <b-alert variant="warning" v-else show>
                    <div class="text-center p-4">
                      <i class="fa-solid fa-2x fa-heart-pulse"></i>
                      <span>No existen signos registrados.</span>

                    </div>
                  </b-alert>
                </b-col>
              </b-row>
              <hr>
                <b-row>

                
                <b-col>
                  <label>Plan de Tratamiento:</label>
                  <b-form-textarea v-model="hospitalizacion.planTratamiento" />
                </b-col>
              </b-row>
            

            </b-card>
          </b-tab>

          
        <b-tab title="Evaluacion Ginecologica">
          <Form013aSemioGineco class="my-1" :dataGinecologia="dataGinecologia" @semiologia-enviada="recibirSemiologia"/>
        </b-tab>


        </b-tabs>
      </div>

      <div class="text-right">
        <b-button variant="primary" class="mr-2" @click="onSaveHospitalizacion">
          Guardar
        </b-button>

        <b-button>
          Cancelar
        </b-button>

      </div>
    </b-card>

  </ModalContainer>

</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { ginecologiaService } from "../../../atencionCita/services";

import { procedimientosFormulariosService, procedimientosService } from "../../services";
import { getDataForms } from "../../helpers/getDataForms";
import Form013aSemioGineco from "./Form013aSemioGineco.vue";

export default {
  components: {
    flatPickr,
    SearchOpts,
    ModalContainer,
    Form013aSemioGineco,
  },

  data() {
    return {

     
      idRegistroForm: null,
      tokenFormulario:null,
      messageAlert: null,
      dataGinecologia: null,
      hospitalizacion: {
        scoreMama:"",
        analisis:"",
        planTratamiento:"",
        motivoConsulta: "",
        problemaActual:"",
        alergiaMedicamentos: "",
        otrasAlergias: "",
        vacunas: "",
        patologiasClinicas: "",
        medicacionHabitual: "",
        quirurgicos: "",
        resumenEvolucion: "",
        hallazgosRelevantes: "",
        resumenTratamiento: "",
        indicacionesAlta: "",
        constantesVitales : null,
        diagnosticosList: [],
        causaExterna: "",

        vivoMuerto: "1",
        medicosList: [],
        principal: true,
        selectedCondicion: null,
        selectedTipoAlta: null,
        selectedDefuncion: null,
        diasReposo: '',
        diasEstadia: '',
        obsCondicion: '',
      },

     
    };
  },
  created() {

    this.setDate();
    this.loadData();

    // if (this.jsoFormhospitalizacion) {
    //   this.hospitalizacion = this.jsoFormhospitalizacion
    // }

  },

  props:{
    tokenAtencion:{
      default:null,
      required: false
    },
    dataProceso:{
      default:null,
      required:false,
    }

  },

  methods: {

     recibirSemiologia(obj) {
      this.dataGinecologia = obj
      
    },

    constantesVitales(constantesVitalesAtencion){
       let tensionArterial = `${constantesVitalesAtencion.tensionArterialSistolica}/${constantesVitalesAtencion.tensionArterialDiastolica}`
          this.hospitalizacion.constantesVitales = {
            tensionArterial: tensionArterial,
            frecuenciaCardiaca: constantesVitalesAtencion.pulso,
            frecuenciaRespiratoria: constantesVitalesAtencion.freqRespiratoria,
            temperatura: constantesVitalesAtencion.temperatura,
            saturacionOxigeno: constantesVitalesAtencion.satOxigeno,
            peso: constantesVitalesAtencion.peso,
            talla: constantesVitalesAtencion.talla,
            imc: constantesVitalesAtencion.imc,
            scoreMama: null,
            otros:null
            
          }
    },

    async loadData() {
      this.hospitalizacion = {
        resumenEvolucion: "",
        hallazgosRelevantes: "",
        resumenTratamiento: "",
        indicacionesAlta: "",


        diagnosticosList: [],
        causaExterna: "",
        constantesVitales:null,
        vivoMuerto: "1",
        medicosList: [],
        principal: true,
        selectedCondicion: null,
        selectedTipoAlta: null,
        selectedDefuncion: null,
        diasReposo: '',
        diasEstadia: '',
        obsCondicion: '',
      }
      
      this.idRegistroForm = null;

      this.tokenProceso = this.$route.query.forms
      const tokenFormulario = this.$route.query.f003;
      this.tokenFormulario = tokenFormulario
      const responseGet = await procedimientosFormulariosService.obtenerFormProcDataByToken(tokenFormulario);

      console.log("response get", responseGet)

      let constantesVitalesAtencion = await procedimientosService.getSignosByTokenProc(this.tokenProceso)

      if (responseGet) {
        this.messageAlert = {
          variant: "success",
          text: "Se encontró información registrada, se procederá a actualizar"
        }

       

      } else {
        this.messageAlert = {
          variant: "warning",
          text: "No se encontró informacion registrada"
        }

        

        if (constantesVitalesAtencion) {
         this.constantesVitales(constantesVitalesAtencion)
        }
        if (this.tokenAtencion){
        const dataGinecologia = await ginecologiaService.getAntecedentesByAtencion(this.tokenAtencion)
        console.log("entra a recolectar data ginecologica", dataGinecologia)
        this.dataGinecologia = dataGinecologia?.dataItems
        }
        
        return;
      }

      let paciente = `${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.identificacion}-${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

      const dataProceso = {
        paciente: paciente,
        codigo: responseGet.procedimientoCita.procedimiento.codigo,
        descripcion: responseGet.procedimientoCita.procedimiento.descripcion
      }

      try {
        const hospitalizacion = JSON.parse(responseGet.dataJson)
        this.hospitalizacion = hospitalizacion
       
        if(!hospitalizacion.constantesVitales && constantesVitalesAtencion) {         
         this.constantesVitales(constantesVitalesAtencion)
        
        }

        this.dataGinecologia = hospitalizacion.dataGinecologia
        
      } catch (error) { console.log("error", error) }


      
      this.idRegistroForm = responseGet.id;

    },

    setDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },


  


    async onSaveHospitalizacion() {

      const params = {
        nameForm: "003",
        dataJson: JSON.stringify(this.hospitalizacion),
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm,
        tokenFormulario: this.tokenFormulario
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

      this.$emit("formulario-guardado");
      
      await this.$router.push({ query: { ...this.$route.query, f003: undefined } });


    },
  },

  watch: {


    '$route.query.f003': {
      handler(newValue) {
        if (newValue) { this.loadData() }

      },
    },

    dataGinecologia:{
      handler(newValue){
        this.hospitalizacion.dataGinecologia = newValue
      }
    }

   
  }

};
</script>

<style scoped>
.flatpickr-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.parpadeo {
  font-weight: 200;
}
</style>
